import styled from 'styled-components'
import { breakpoints, colors } from 'style'

export const HomeRoadBlocksContainer = styled.div`
  position: relative;
  width: 100%;
  display: flex;
  flex-direction: column;
  background-color: ${colors.gray};
  .container {
    .description-sm {
      display: none;
    }
    .roadblocks-wrapper {
      padding: 90px 0px;
      display: flex;
      flex-wrap: wrap;
      h2 {
        margin-bottom: 60px;
        color: ${colors.blueDark};
      }
      .roadblock-item {
        width: 50%;
        display: flex;
        align-items: center;
        color: ${colors.blueDark};
        margin-bottom: 60px;
        .img-wrapper {
          margin-right: 24px;
          img {
            width: 184px;
          }
        }
        .roadblock-content {
          padding-right: 50px;
          h3 {
            margin-bottom: 20px;
            color: ${colors.blueDark};
          }
          h4 {
            color: ${colors.blueDark};
          }
        }
      }
    }
    .roadblocks-wrapper-sm {
      display: none;
    }
  }
  @media (max-width: ${breakpoints.md}px) {
    padding: 26px 0;
    .container {
      .description-sm {
        display: block;
        h3 {
          font-size: 32px;
          line-height: 41px;
          color: ${colors.blueDark};
          margin-bottom: 30px;
        }
      }
      .roadblocks-wrapper {
        display: none;
      }
      .roadblocks-wrapper-sm {
        display: block;
        padding: 0 30px;
        .roadblock-item {
          .img-wrapper {
            display: flex;
            align-items: center;
            img {
              width: 112px;
            }
          }
          h3,
          h4 {
            color: ${colors.blueDark};
          }
        }
        .carousel-inner {
          /* border: 1px solid ${colors.blueDark};
          box-shadow: 1px 4px 4px ${colors.blueDark}; */
          border-radius: 5px;
          padding: 26px 16px 67px;
        }
        .carousel-control-next,
        .carousel-control-prev {
          width: 20px;
        }
        .carousel-indicators {
          li {
            width: 10px;
            height: 10px;
            border-radius: 50%;
            margin-right: 5px;
            margin-left: 5px;
            background-color: ${colors.grayLight};
            &.active {
              background-color: ${colors.blueDark};
            }
          }
        }
      }
    }
  }
  @media (max-width: ${breakpoints.sm}px) {
    .container {
      .roadblocks-wrapper-sm {
        .roadblock-item {
          .img-wrapper {
            img {
              width: 90px;
            }
          }
        }
      }
    }
  }
  @media (max-width: 413px), (max-height: 845px) {
  }
`
